<template>
    <div id="chat-container">
        <div class="chat-img-wrapper" v-on:click="toggleChatWindow">
            <img src="../assets/images/icons/chat.svg" alt="Chat Bubble" class="chat-icon">
        </div>
        <div class="chat-prompt">
            <span>
                ¿Tienes una consulta?
                <br>
                Estamos para servirte!
            </span>
        </div>
        <div id="chat-window" v-bind:class="{'show-chat-window' : isChatWindowVisible}">
            <div class="info-prompt" :style="promptStyleObject">
                <img src="../assets/images/icons/icons8-close.svg" alt="Close" class="close-chat-window"
                     v-on:click="exitChat">
                <h2 class="info-prompt-title">Nos ayudas con un poco de información</h2>
                <form action="#" @submit.prevent="initializeChat">
                    <label for="username">Nombre Completo</label>
                    <br>
                    <input type="text" id="username" maxlength="30" v-model="client_name">
                    <br>
                    <br>
                    <!--<label for="category">Categoría</label>-->
                    <!--<br>-->
                    <!--<select name="category" id="category">-->
                    <!--<option value="">&#45;&#45; Seleccione una Categoría &#45;&#45;</option>-->
                    <!--<option value="">Más información sobre paquetes</option>-->
                    <!--<option value="">Más información sobre las instalaciones</option>-->
                    <!--<option value=""></option>-->
                    <!--</select>-->
                    <!--<br>-->
                    <label for="question">Pregunta</label>
                    <br>
                    <input type="text" id="question" maxlength="30" v-model="question">
                    <input type="submit" value="Enviar" class="send">
                    <div class="errors-wrapper" v-if="errors.length">
                        <ul>
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>
                </form>
            </div>
            <div id="conversation-wrapper" :style="chatStyleObject">
                <header id="chat-window-header">
                    <h1 class="window-title">Ayuda En Linea!</h1>
                    <div class="actions">
                        <img src="../assets/images/icons/down-arrow.svg" alt="Minimize"
                             v-on:click="hideChatWindow">
                        <img src="../assets/images/icons/icons8-close.svg" alt="Close"
                             v-on:click="exitChat">
                    </div>
                </header>
                <div id="chat-window-messages">
                    <LiveChatMessage class="support"
                                     message="Hola, mi nombre es Mariel Galindo. En que puedo ayudarle?"/>
                </div>
                <div id="chat-window-input">
                    <input type="text" class="input-box" v-model="inputBoxMessage"
                           @keyup.enter="sendClientMessage">
                    <div class="send-wrapper">
                        <img src="../assets/images/icons/send.svg" alt="Send"
                             @click="sendClientMessage">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import LiveChatMessage from '@/components/LiveChatMessage';
    import Vue from 'vue'

    export default {
        name: "LiveChat",
        components: {
            LiveChatMessage
        },
        data() {
            return {
                isChatWindowVisible: false,
                isChatInitialized: false,
                client_name: "",
                question: "",
                errors: [],
                inputBoxMessage: ""
            }
        },
        computed: {
            promptStyleObject() {
                if (this.isChatInitialized === false) {
                    return {
                        display: 'block'
                    }
                }
                return {
                    display: 'none'
                }
            },
            chatStyleObject() {
                if (this.isChatInitialized === true) {
                    return {
                        display: 'flex'
                    }
                }
                return {
                    display: 'none'
                }
            }
        },
        methods: {
            initializeChat() {
                this.errors = [];
                this.client_name = this.client_name.trim();
                this.question = this.question.trim();

                if (this.client_name.length === 0) {
                    this.errors.push("Por favor ingrese su nombre completo")
                }

                if (this.question.length === 0) {
                    this.errors.push("Por favor ingrese una pregunta")
                }

                if (this.errors.length > 0)
                    return;

                this.isChatInitialized = true;

            },
            sendClientMessage() {
                if (this.inputBoxMessage.length <= 0) {
                    return;
                }
                let chat_message_container = document.getElementById("chat-window-messages");
                let LiveMessage = Vue.extend(LiveChatMessage);
                let component = new LiveMessage({
                    propsData: {message: this.inputBoxMessage}
                }).$mount();
                component.$el.classList.add("client");
                chat_message_container.appendChild(component.$el);
                this.inputBoxMessage = "";

            },
            toggleChatWindow() {
                this.isChatWindowVisible = !this.isChatWindowVisible;
                this.$emit('toggle-body-overflow', this.isChatWindowVisible);
                if (this.isChatWindowVisible === true) {

                }
            },
            hideChatWindow() {
                this.isChatWindowVisible = false;
                this.$emit('toggle-body-overflow', this.isChatWindowVisible);
            },
            exitChat() {
                // Mostrar una confirmación antes de realizar la operación
                this.isChatWindowVisible = false;
                this.$emit('toggle-body-overflow', this.isChatWindowVisible);
            }
        }
    }
</script>

<style scoped>

    #chat-container {
        position: fixed;
        right: 15px;
        bottom: 15px;
        background-color: #e46658;
        width: 65px;
        height: 65px;
        z-index: 20;
        border-radius: 50%;
    }

    #chat-container .chat-img-wrapper {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
    }

    #chat-container .chat-icon {
        width: 65%;
    }

    #chat-container .chat-prompt {
        width: 200px;
        position: absolute;
        background-color: #FFF;
        word-wrap: break-word;
        top: -70px;
        left: -165px;
        border-radius: 4px;
        box-shadow: 0 1px 2px #3d3d3d;
        padding: 10px;
        color: #e46658;
        border: 1px solid #e46658;
        display: none;
    }

    #chat-window {
        background-color: #FFF;
        width: 400px;
        height: 500px;
        position: absolute;
        top: -510px;
        left: -345px;
        border: 1px solid #e46658;
        border-radius: 5px;
        box-shadow: 0 3px 5px #3d3d3d;
        display: none;
        justify-content: center;
    }

    #chat-window .info-prompt {
        margin: 0 25px;
    }

    #chat-window .info-prompt .close-chat-window {
        width: 25px;
        cursor: pointer;
        position: absolute;
        right: 5px;
        top: 5px;
    }

    #chat-window .info-prompt-title {
        text-align: center;
        font-weight: 500;
        font-size: 1.3rem;
        border-bottom: 1px solid #999;
    }

    #chat-window .info-prompt .send {
        margin-top: 10px;
        cursor: pointer;
    }

    #chat-window .info-prompt .errors-wrapper ul {
        padding: 0;
        margin: 10px 0 0 0;
        color: #F00;
        list-style-type: circle;
        text-align: center;
        font-size: 1.1rem;
    }

    #conversation-wrapper {
        display: none;
        flex-direction: column;
    }

    #chat-window #chat-window-header {
        border-bottom: 1px solid #e46658;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 5px 10px;
    }

    #chat-window #chat-window-header .window-title {
        margin: 0;
        font-size: 1.1rem;
    }

    #chat-window #chat-window-header .actions img {
        width: 25px;
        margin-left: 10px;
        cursor: pointer;
    }

    #chat-window #chat-window-messages {
        flex-grow: 10;
        overflow-y: scroll;
        padding: 10px;
        display: flex;
        flex-direction: column;
    }

    #chat-window #chat-window-input {
        background-color: #FFF;
        padding: 5px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-top: 1px solid #e46658;
    }

    #chat-window #chat-window-input .input-box {
        width: 85%;
        padding: 0 10px 5px 10px;
        font-size: 16px;
        background-color: transparent;
        border: 0;
        border-bottom: 2px solid #666;
    }

    #chat-window #chat-window-input .input-box:focus {
        outline: 0;
        border-bottom: 2px solid #e46658;
    }

    #chat-window #chat-window-input .send-wrapper {
        width: 6%;
    }

    .show-chat-window {
        display: flex !important;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        #chat-container {
            width: 60px;
            height: 60px;
        }

        #chat-container .chat-prompt {
            width: 200px;
            top: -70px;
            left: -170px;
        }

        #chat-window {
            width: 100vw;
            height: 100%;
            top: 0;
            left: 0;
            position: fixed;
            border: 0;
            border-radius: 0;
        }

        #chat-window #chat-window-header .window-title {
            margin: 0;
        }

        #chat-window #chat-window-header .actions img {
            width: 35px;
            margin-left: 15px;
        }

        #chat-window #chat-window-messages .message {
            width: 65%;
            margin-top: 15px;
            border-radius: 10px;
            padding: 10px;
            font-size: 16px;
        }

        #chat-window #chat-window-input .send-wrapper {
            width: 10%;
        }

    }
</style>